import {handleActions} from 'redux-actions'
import reducerGenerator from '../comments/reducerGenerator'
import * as ActionTypes from './actionTypes'

export default (initAppData) => {
    const commentsReducer = reducerGenerator({
        actionTypes: ActionTypes,
        initAppData: {
            ...initAppData,
            newCommentsTexts: initAppData.COMMENTS.PROJECT_NEW_COMMENTS
        }
    })

    const initialState = {
        openProjectId: null,
        openedFromUrl: false,
        allTasksAssigned: false,
        canManage: false,
        ...commentsReducer.initialState,
    }

    return handleActions({
        [ActionTypes.OPEN_PROJECT_SET]: (state, {payload: openProjectId}) => ({...state, openProjectId}),
        [ActionTypes.PROJECT_PANEL_OPENED_FROM_URL_SET]: (state, {payload: openedFromUrl}) => ({...state, openedFromUrl}),
        [ActionTypes.ALL_TASKS_ASSIGNED_SET]: (state, {payload: allTasksAssigned}) => ({...state, allTasksAssigned}),
        [ActionTypes.CAN_MANAGE_SET]: (state, {payload: canManage}) => ({...state, canManage}),
        ...commentsReducer.handlers,
    }, initialState)
}


// WEBPACK FOOTER //
// ./web/js/panels/project/reducer.js